__webpack_require__.p = "/Digital-Card/";